module.exports = __webpack_public_path__ + "src/components/Header/LOGO.svg?5b0d9b84";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/LOGO.svg
// module id = 2797
// module chunks = 1